//
//
//
//
//
//
//
//

import { App_User } from '@/data/user_info'
import TASK_LIST from '@/data/unhandle_task'

export default {
    props: {
        favourite: Boolean
    },
    data () {
        return {
        }
    },
    methods: {
        checkUser() {
            App_User.get().then((data) => {
                if (data.tag_list[0] == "天府通游客") {
                    wx.navigateTo({
                        url: '/logging_in'
                    })
                    TASK_LIST.addTask(() => {
                        this.$emit('finally')
                    })
                } else {
                    this.$emit('finally')
                }
            })
        }
    }
}
